<template>
    <div class="election-closed-card card" >
        <div class="card-header">
            <h3 class="card-title">Voting has ended</h3>
        </div>

        <div class="card-body">
            <p class="card-text">Voting has ended. The results are being reviewed and certified. Once
                that has taken place, you will be able to view them here. </p>
        </div>


    </div>
</template>

<script>
export default {
    name: "election-closed-card",

    props: [],

    mixins: [],

    data: function () {
        return {}
    },


    computed: {},

    methods: {}

}
</script>

<style scoped>

</style>
